import { render, staticRenderFns } from "./DatabaseTable.vue?vue&type=template&id=2be981ff&scoped=true&"
import script from "./DatabaseTable.vue?vue&type=script&lang=js&"
export * from "./DatabaseTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be981ff",
  null
  
)

export default component.exports